import clsx from 'clsx';

import style from '../aboutObject/styles.module.scss';
import { AboutObjectEstimateMarketPrice } from './aboutObjectEstimateMarketPrice';
interface IAboutObjectEstimatesProps {
  maxFacilityPrice: string;
  minFacilityPrice: string;
  marketPrice: string;
}

const AboutObjectEstimateInSystem = ({
  marketPrice,
  maxFacilityPrice,
  minFacilityPrice,
}: IAboutObjectEstimatesProps) => {
  return (
    <div className={style.aboutObject}>
      <div
        className={clsx(style.aboutObject__container, style.aboutObject__container_withoutMargin)}
      >
        <div className={clsx(style.aboutObject__card, style.aboutObject__withoutCard)}>
          <div>
            <AboutObjectEstimateMarketPrice
              marketPrice={marketPrice}
              maxFacilityPrice={maxFacilityPrice}
              minFacilityPrice={minFacilityPrice}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutObjectEstimateInSystem;
